import { useBase64 } from "@vueuse/core";
// uint8Array -> base64 image;
export function uint8ArrayToBase64(uint8Array) {
  return new Promise((resolve, reject) => {
    // 创建FileReader对象;
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error);
    const blob = new Blob([uint8Array]);
    reader.readAsDataURL(blob);
  });
}

// base64转Blob;
export function base64toBlob(dataurl: string) {
  let arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}

// base64转File;
export function base64toFile(dataurl: string, fileName: string = uuid()) {
  let arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  const theBlob = new Blob([u8arr], { type: mime }) as any;
  const imageName = `${fileName}.${theBlob.type.replace("image/", "")}`;
  theBlob.lastModifiedDate = new Date(); // 文件最后的修改日期
  theBlob.name = imageName; // 文件名
  // console.log("image blob: ", theBlob);
  return theBlob;
  // 使用File实例在SSR - error;
  // return new File([theBlob], imageName, {
  //   type: theBlob.type,
  //   lastModified: Date.now(),
  // });
}

/**
 * @description: 图片文件转Base64
 * @param {} file 文件
 * @return {String}
 */
export function fileToBase64(file: any): Promise<FileReader["result"]> {
  return useBase64(file).promise.value;
}

/**
 * @description: 图片文件转字符串
 * @param imageUrl 网络图片链接
 * @return {String}
 */
export async function imageUrlToBase64(imageUrl: string) {
  try {
    // 使用fetch获取图片资源
    const response = await fetch(imageUrl);
    const blob = await response.blob();

    // 将Blob对象转换为Base64编码
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = function () {
        resolve(reader.result);
      };
      reader.onerror = function () {
        reject(new Error("读取图片失败"));
      };
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error("转换图片链接为Base64时出错：", error);
    return null;
  }
}

export const getImagePreViewUrl = async (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => resolve(e.target?.result);
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
  });
};
